<igo-ogc-filterable-item
  [map]="map"
  [layer]="layer"
  [header]="false"
  [@toolSlideInOut]="animate"
/>
